import Skeleton from "@mui/material/Skeleton";
const TourCardSkeleton = () => {
  return (
    <div className="tourCard">
      <Skeleton variant="rectangular" width="100%" height={180} />

      <div style={{ padding: "10px" }}>
        <Skeleton variant="text" width="80%" height={30} />
        <Skeleton variant="text" width="60%" height={25} />
        <Skeleton variant="text" width="40%" height={25} />

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
          <Skeleton variant="text" width="30%" height={30} />
          <Skeleton variant="rectangular" width={80} height={35} />
        </div>
      </div>
    </div>
  );
};

export default TourCardSkeleton;